import { render, staticRenderFns } from "./release-notes-tab.vue?vue&type=template&id=e664e574"
import script from "./release-notes-tab.vue?vue&type=script&lang=js"
export * from "./release-notes-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports